import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { TagDto } from '@picflow/types';
import { DialogOptions } from 'src/app/interfaces/dialog-data.interface';
import { OnGetData } from 'src/app/services/dialog.service';
import { ToastService } from 'src/app/services/toast.service';
import { ButtonDirective } from 'src/app/shared/directives/button.directive';
import { TagService } from 'src/app/tag.service';
import { LoadingIndicatorComponent } from '../../../shared/components/loading-indicator/loading-indicator.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';

@Component({
  selector: 'app-delete-tag-dialog',
  standalone: true,
  templateUrl: './delete-tag-dialog.component.html',
  styleUrls: ['./delete-tag-dialog.component.scss'],
  imports: [SvgComponent, ButtonDirective, LoadingIndicatorComponent, NgIf],
})
export class DeleteTagDialogComponent implements OnGetData {
  dialogName = 'delete-tag';
  tag: TagDto;
  close: () => void;
  loading = false;

  dialogOptions(): DialogOptions {
    return { hasSmallBottomPart: true };
  }

  constructor(private tagService: TagService, private toats: ToastService) {}

  onGetData(data: { tag: TagDto }, close: () => void) {
    this.close = close;
    this.tag = data.tag;
  }

  confirm() {
    this.loading = true;
    return this.tagService.deleteTag(this.tag.id).subscribe(() => {
      this.toats.add('Tag deleted', 'success');
      this.close();
    });
  }
}
